import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { SCAMP_API } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { DashboardUmParameters } from '../pages/domain/viewmodels.models';


@Injectable({providedIn: 'root'})
export class DashboardService {

    constructor(
        private http: HttpClient,
        private account: AccountService
    ) { }

    getDashboardUm(parameters: DashboardUmParameters): Observable<any> {

        return this.http.post<any>(
            `${SCAMP_API.accountApiV1}/dashboard-um`, parameters,
            {headers : this.account.composeHeaders()}
            );
    }

    getQuantitativoServicos(ano: number): Observable<any[]> {
        return this.http.get<any[]>(
            `${SCAMP_API.accountApiV1}/quantitativo-servicos/${ano}`,
            {headers : this.account.composeHeaders()}
            );
    }

    exportarQuantitativoServicosToExcel(ano: number): Observable<any> {
        return this.http.get<any>(`${SCAMP_API.accountApiV1}/quantitativo-servicos/excel/${ano}`,
            { headers: this.account.composeHeaders() });
    }

}
